import { t as sharedT } from '@cloudsign/shared';
import type { ApiError } from '@cloudsign/shared';

/** All user-facing text goes through the shared catalogue (English UK). */
export const t = sharedT;

/** Hook form, so a future per-user locale can be injected without touching call sites. */
export function useT(): typeof sharedT {
  return sharedT;
}

/** Translate an API error body's message key and params. */
export function errorText(error: ApiError['error'] | null | undefined): string {
  if (!error) return t('error.internal');
  return t(error.messageKey, error.params);
}
